<template>
	<inertia-head title="Diamond Class" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">Diamond Class</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import AuthLayout from '../../../Layouts/AuthLayout'

export default {
	layout: AuthLayout,
}
</script>
